import React from 'react';

import QueueRowItem from './queue-row';
import { QueueRow } from '../types';

interface QueueListRowProps {
  index: number;
  style: React.CSSProperties;
  data: {
    queuedJobs: QueueRow[];
    onAssignUser: (queueCase: QueueRow, newOperatorId: string) => void;
  };
}

const QueueListRow: React.FC<QueueListRowProps> = ({
  index,
  style,
  data,
}) => {
  const { queuedJobs, onAssignUser } = data;

  return (
    <div style={{ ...style, width: '100%' }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <QueueRowItem
          queueCase={queuedJobs[index]}
          onAssignUser={onAssignUser}
        />
      </div>
    </div>
  );
};

export default QueueListRow;
